// extracted by mini-css-extract-plugin
module.exports = {"callout":"RadixOverrides_callout__1dv7O","avatar":"RadixOverrides_avatar__A_2NH","link":"RadixOverrides_link__7_hRn","darkLink":"RadixOverrides_darkLink__41n7d"};